export const appStrings_enAU = {
	'TO': {
		'fees': 'Surcharge',
	},
};
